enum SupportedLanguages {
  de = 'de',
  en = 'en',
}

export { SupportedLanguages };
